module.exports = __webpack_public_path__ + "img/baby-vinyl_banner.0eccebcd.png";